import { getUserInfo } from './api';
import { refreshToken } from './doctor-api';
import { createGroup ,getBaseUserInfo} from '@/service/api';
import { saveLastOpenChatTime } from '@/service/friend-api';
import { Base64 } from 'js-base64';
import { encode, decode } from 'js-base64';
import store from '../store/index'
import {webSaveParams} from "@/service/jsbridge";
import {doctorUserStatus} from "@/service/h5-api";
import { getPageQuery,getMobileOperatingSystem } from "@/utils/common.ts";

const common = {
  //全局获取用户信息。判断是否登录
  wxLoginOld: function (callback) {
    //获取登录信息
    uni.login({
      success: function (res) {
        return new Promise((resolve, reject) => {
          getUserInfo({
            loginCode: res.code,
            mobile: uni.getStorageSync('modifyPhoneNumber'),
          })
            .then((userInfo) => {
              if (userInfo.code == 601) {
                uni.redirectTo({
                  url: '/pages/login/login',
                });
                reject();
              }
              if (userInfo.data) {
                uni.setStorageSync('authorization', userInfo.data);
                var wxUserInfoSync =
                  JSON.parse(Base64.decode(userInfo.data.split('.')[1]))
                    .userInfo || null;
                //如果有手机号就登陆，没有手机号就跳转登陆页面 todo
                console.log('wxUserInfoSync==', wxUserInfoSync);
                uni.setStorageSync('wxUserInfoSync', wxUserInfoSync);
                if (
                  wxUserInfoSync.mobile &&
                  wxUserInfoSync.mobile.length == 11 &&
                  wxUserInfoSync.userNick
                ) {
                  uni.setStorageSync('wxUserInfoSync', wxUserInfoSync);
                } else {
                  uni.redirectTo({
                    url: '/pages/login/login',
                  });
                }
                resolve();
                callback ? callback() : '';
              }
            })
            .catch((err) => {
              console.log('全局获取用户信息。判断是否登录');
              reject();
            });
        });
      },
    });
  },
  wxLogin(callback) {

    setTimeout(() => {
      callback ? callback() : '';
    }, 1000);
    return;


    /*
		判断有无authorization缓存，有：刷新token,---缓存authorization,判断角色，判断进入的页面，登陆im，;
		无：跳转到登陆页,---缓存authorization,判断角色，判断进入的页面，登陆im，;
		*/
    return new Promise((resolve, reject) => {
      let callBackUrl = uni.getStorageSync('callBackUrl');
      //返回一个布尔值，值为true时表示包含
      let isUrl = callBackUrl.includes('pagesChat/doctor');
      console.log(
        isUrl,
        'isUrl--判断有无authorization缓存',
        uni.getStorageSync('wxUserInfoSync')
      );
      if (
        uni.getStorageSync('authorization') &&
        uni.getStorageSync('wxUserInfoSync')
      ) {
        refreshToken({
          token: uni.getStorageSync('authorization'),
        }).then((res) => {
          uni.setStorageSync('authorization', res.data);
          var wxUserInfoSync =
            JSON.parse(Base64.decode(res.data.split('.')[1])).userInfo || null;
          uni.setStorageSync('wxUserInfoSync', wxUserInfoSync);
        });
        console.log(
          '判断有无authorization缓存--isStaff',
          uni.getStorageSync('wxUserInfoSync').isStaff
        );
        //isStaff：0用户，1医生
        if (uni.getStorageSync('wxUserInfoSync').isStaff == 0) {
          if (isUrl) {
            uni.reLaunch({
              url: '/pagesChat/doctor/index',
            });
          }
          callback ? callback() : '';
          resolve();
        } else if (uni.getStorageSync('wxUserInfoSync').isStaff == 1) {
          if (!isUrl) {
            {
              uni.reLaunch({
                url: '/pages/index/index',
              });
            }
          }
          callback ? callback() : '';
          resolve();
        }
      } else {
        console.log('判断有无authorization缓存---无：跳转到登陆页');
        uni.redirectTo({
          url: '/pages/login/login',
        });
      }
    });
  },
  getToken() {
    return new Promise((resolve, reject) => {
      lkszfwToken({
        appid: 'VF-g_T7VR',
      }).then((res) => {
        if (res.code == 0) {
          console.log('console=Token');
          uni.setStorageSync('lkszfwToken', res.data.token || '');
          resolve(true);
        } else {
          uni.showToast({
            title: res.message,
            icon: 'none',
            duration: 2000,
          });
          resolve(false);
        }
      });
    });
  },
  getUuid () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0
      const v = c === 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  },
  /**
   * 将API接口的消息转换为 腾讯的 message类型返回
   */
  formatMsg(conversationID, data) {
    let body = data.msgBody || '**解析出错**';
    let type = uni.$TIM.TYPES.MSG_TEXT;
    try {
      let msgBody =
        data.msgBody && 'string' === typeof data.msgBody
          ? JSON.parse(data.msgBody)
          : [];

      body = msgBody && msgBody.length ? this.messageToFormat(msgBody[0]) : {};
      type = msgBody && msgBody.length ? msgBody[0].msgType : {};
    } catch (e) {
      console.error('formatMsg error :', e);
    }
    if (
      'undefined' === typeof data.msgBody &&
      data.exitType === 'Quit' &&
      data.exitMemberList
    ) {
      let userIDList = [];
      for (const v of data.exitMemberList) {
        userIDList.push(v['Member_Account']);
      }
      type = uni.$TIM.TYPES.MSG_GRP_TIP;
      body = {
        payload: {
          operationType: uni.$TIM.TYPES.GRP_TIP_MBR_QUIT,
          userIDList,
        },
      };
    }
    return {
      ID:
        conversationID +
        '-' +
        (data.msgSeq || data.msgTime) +
        '-' +
        (data.msgRandom || data.random || Math.floor(Math.random() * 10000)) +
        '-0'+ this.getUuid(),
      type,
      id: data.id,
      msgSeq: data.msgSeq,
      payload: body.payload,
      clientSequence: data.msgSeq,
      conversationID,
      conversationType: 'GROUP',
      to: data.operatorAccount,
      from: data.fromAccount,
      flow:
        data.fromAccount ===
        process.env.VUE_APP_USERID + uni.getStorageSync('wxUserInfoSync').id
          ? 'out'
          : 'in',
      time: data.msgTime,
      status: 'success',
      isRevoked: data.isRecalled || false,
      nick: data.baseUserInfo.userNick,
      nameCard: '',
      avatar: data.baseUserInfo.headUrl,
      cloudCustomData: data.cloudCustomData || "",
      isDeleted: data.isDeleted || false,
      random: data.msgRandom || data.random,
      highlightText: data.msgShow || '',
    };
  },
  messageToFormat(message) {
    let result = {
      type: uni.$TIM.TYPES.MSG_TEXT,
      payload: {
        text: '',
      },
    };
    try {
      result.type = message.msgType;
      result.payload = this.payloadToFormat(message.msgContent);
    } catch (e) {
      console.log(message);
      console.error('format error :', e);
    }
    return result;
  },

  payloadToFormat(content) {
    if (!content || 'string' === typeof content) {
      return content;
    }
    let msg = Array.isArray(content) ? [] : {};
    for (const k in content) {
      if (Array.isArray(content[k])) {
        msg[this.messageKeyMap(k)] = this.payloadToFormat(content[k]);
      } else if ('object' === typeof content[k]) {
        msg[this.messageKeyMap(k)] = this.payloadToFormat(content[k]);
      } else {
        msg[this.messageKeyMap(k)] = content[k];
      }
    }
    return msg;
  },
  getUrlName(name) {
    let curPage = getCurrentPages();
    let route = curPage[curPage.length - 1].route; //获取当前页面的路由
    let params = curPage[curPage.length - 1].options; //获取当前页面参数，如果有则返回参数的对象，没有参数返回空对象{}
    if (Object.keys(params).length > 0) {
      for (var key in params) {
        if (name == key) {
          return params[key];
        }
      }
    }
  },
  /**
   * 获取页面地址
   */
  getPath() {
    try {
      let curPage = getCurrentPages();
      //获取当前页面的路由
      let route = curPage[curPage?.length - 1]?.route || '';
      //获取当前页面参数，如果有则返回参数的对象，没有参数返回空对象{}
      let params = curPage[curPage?.length - 1]?.options || {};
      let param = '';
      if (Object.keys(params).length > 0) {
        for (var key in params) {
          param = param + key + '=' + params[key] + '&';
        }
      }
      return route + '?' + param;
    } catch (err) {
      console.log('获取页面地址!=!', err);
    }
  },
  /**
   * 获取分享页面地址
   */
  async sharePath(path, query) {
    const pages = getCurrentPages(); // 获取页面栈
    console.log(window.location.href,'--分享页面地址pages', pages);
    console.log('分享页面地址', path,query);
    try {
      var param,h5Token = '';
      if (Object.keys(query).length > 0) {
        for (var key in query) {
          param = param + key + '=' + query[key] + '&';
          if(key == 'token'){
            h5Token = query[key]
          }
        }
      }
      console.log(h5Token=="",'token=',h5Token,'分享页面地址', path + '?' + param);
      if(h5Token==""){
        h5Token = this.getTokenFromUrl();
        console.log('重新获取token=',h5Token);  
      }
      uni.setStorageSync('callBackUrl', path + '?' + param);

      if(h5Token){
        uni.setStorageSync('authorization', h5Token);
        console.log(h5Token.split('.').length )
        var userId = null
        if (h5Token.split('.').length > 2) {
          userId = JSON.parse(Base64.decode(h5Token.split('.')[1]))
            .healthUserId || null;
        }
        console.log('---userId --',userId)
        //todo 获取用户信息
        let {data}= await getBaseUserInfo({userId})
        let wxUserInfoSync = data || {};
        uni.setStorageSync('wxUserInfoSync', {...wxUserInfoSync,id:userId});
        webSaveParams({"token":h5Token,"wxUserInfoSync": {...wxUserInfoSync,id:userId}})
      }

      return path + '?' + param;
    } catch (err) {
      // console.log('获取页面地址!=!', err);
    }
  },
  getTokenFromUrl() {
      // 获取当前页面的 URL
      const url = window.location.href;

      // 使用 URLSearchParams 解析查询参数
      const params = new URLSearchParams(url.split('?')[1]);

      // 获取 token 参数的值
      const token = params.get('token');

      // 返回 token
      return token;
  },
  /**
   * 格式化payload内容
   */
  messageKeyMap(k) {
    let lowerK = k.toLowerCase();
    switch (lowerK) {
      case 'desc':
        return 'description';
      case 'ext':
        return 'extension';
      default:
        if (k.length > 1 && k.substr(1, 1).toLowerCase() === k.substr(1, 1)) {
          return k.substr(0, 1).toLowerCase() + k.substr(1); // lowerK
        } else {
          return lowerK;
        }
    }
  },
  //
  /**
   * 埋点数据
   * bizTypeId:业务类型，bizTypeChildId:业务子类型,sceneDesc:场景描述, data：json业务数据信息
   */
  mdTrack(bizTypeChildId, sceneDesc, data) {
    const wxUserInfoSync = uni.getStorageSync('wxUserInfoSync')
    // eventTrack({
    //   bizTypeId: 'e家管家',
    //   bizTypeChildId: this.getPath(),
    //   curAppkey: 'hb_' + process.env.VUE_APP_TRACK_ENV,
    //   userId: wxUserInfoSync&&wxUserInfoSync.id || 'wxUserInfoSync不存在',
    //   created: this.getNowTime(),
    //   sceneDesc,
    //   data,
    //   token:uni.getStorageSync('authorization')||"token不存在"
    // }).then((res) => {});
  },
  getNowTime() {
    let now = new Date();
    let year = now.getFullYear(); //获取完整的年份(4位,1970-????)
    let month = now.getMonth() + 1; //获取当前月份(0-11,0代表1月)
    let today = now.getDate(); //获取当前日(1-31)
    let hour = now.getHours(); //获取当前小时数(0-23)
    let minute = now.getMinutes(); //获取当前分钟数(0-59)
    let second = now.getSeconds(); //获取当前秒数(0-59)
    let nowTime = '';
    nowTime =
      year +
      '-' +
      this.fillZero(month) +
      '-' +
      this.fillZero(today) +
      ' ' +
      this.fillZero(hour) +
      ':' +
      this.fillZero(minute) +
      ':' +
      this.fillZero(second);
    return nowTime;
  },
  fillZero(str) {
    var realNum;
    if (str < 10) {
      realNum = '0' + str;
    } else {
      realNum = str;
    }
    return realNum;
  },
  //退出登陆
  logout() {
    uni.removeStorageSync('callBackUrl');
    uni.removeStorageSync('TIMGroupID');
    uni.removeStorageSync('TIMConsultID');
    uni.removeStorageSync('modifyPhoneNumber');
    uni.removeStorageSync('wxUserInfoSync');
    uni.removeStorageSync('authorization');
    uni.removeStorageSync('patientDay');
    uni.removeStorageSync('patientWeek');
    // store.commit('setMessageList', []);
    // store.commit('chatGroupList', []);
    // store.commit('SET_SHOW_GROUP_NIKE', true);
    store.unregisterModule('setMessageList');
    store.unregisterModule('chatGroupList');
    store.unregisterModule('SET_SHOW_GROUP_NIKE');
    store.hotUpdate(store.state);
    //im推出登陆
    uni.$TUIKit.logout();
  },
  //app.js的onLaunch执行完之后再执行Page的onLoad
  checkLoginCallback(app, callback) {
    console.log(
      'app.js的onLaunch执行完之后再执行Page的onLoad',
      uni.$checkLogin
    );
    if (uni.$checkLogin) {
      callback();
    } else {
      uni.$checkLoginReadyCallback = (res) => {
        callback();
      };
    }
  },
  //日期转换
  getDate(timestamp) {
    timestamp = timestamp ? timestamp : null;
    let date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '年';
    let M =
      (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) + '月';
    let D =
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + '日 ';
    let h =
      (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    let m =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    let s =
      date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m;
  },
  //日期转换
  conversionDate(timestamp) {
    timestamp = timestamp ? timestamp : null;
    let date = new Date(timestamp.replace(/-/g, '/')); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    let Y = date.getFullYear() + '-';
    let M =
      (date.getMonth() + 1 < 10
        ? '0' + (date.getMonth() + 1)
        : date.getMonth() + 1) + '-';
    let D =
      (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
    let h =
      (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    let m =
      date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
    let s =
      date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return Y + M + D + h + m;
  },
  //群列表整理
  groupSort(data) {
    var groupList = [];
    store.state.chatGroupList.map((itn) => {
      if (itn.imGroupId != data.payload.groupProfile.groupID) {
        groupList.push(itn);
      }
    });
    store.commit('SET_CHAT_GROUP_LIST', groupList);
    console.log('群系统通知-数据处理groupList=', groupList);
  },
  //节流
  throttle(fn, delay = 1000) {
    //距离上一次的执行时间
    let lastTime = 0;
    return function () {
      let _this = this;
      let _arguments = arguments;
      let now = new Date().getTime();
      //如果距离上一次执行超过了delay才能再次执行
      if (now - lastTime > delay) {
        fn.apply(_this, _arguments);
        lastTime = now;
      }
    };
  },
  openPDF(fileUrl) {
    uni.downloadFile({
      url: fileUrl, //下载地址接口返回
      success: (data) => {
        if (data.statusCode === 200) {
          //文件保存到本地
          uni.saveFile({
            tempFilePath: data.tempFilePath, //临时路径
            success: function (res) {
              setTimeout(() => {
                //打开文档查看
                uni.openDocument({
                  filePath: res.savedFilePath,
                  success: function (res) {
                    console.log('打开文档成功');
                  },
                });
              });
            },
          });
        }
      },
      fail: (err) => {
        console.log('openPDF', err);
        uni.showToast({
          icon: 'none',
          mask: true,
          title: '失败请重新下载',
        });
      },
    });
  },
  goZX(url){
	createGroup({ sdkAppId: '1400802351' })
    .then((res) => {
      if (res.code == 0) {
        var groupInfo = {
          ...res.data,
          imGroupId: res.data.groupId,
          groupName: '健康咨询',
          type: 3,
        };
		
		uni.setStorageSync('TIMGroupID', groupInfo.groupId);
		uni.setStorageSync('TIMConsultID', groupInfo.consultId);
		uni.setStorageSync('TIMGroupInfo', groupInfo);
		
		uni.reLaunch({
		 url: '/pagesChat/group/index',
		});
      }
    })
    .catch((err) => {
      console.log('请求错误');
    });
  },
  getAppToken(){
    const promise = new Promise((resolve,reject)=>{
      //判断环境
        var u = navigator.userAgent
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        console.log('当前安卓环境');
        // 调用安卓app方法通知app刷新token并回调本地方法
        //（window.android.getToken()是与安卓开发约定好的他把getToken这个方法挂载到H5的window.android上）
        window.android.getToken()
      } else if (isiOS) {
        console.log('当前IOS环境');
        // 调用苹果app方法通知app刷新token并回调本地方法
        //（与ios开发约定好的方法名getToken，.postMessage("获取token")是传参）
        window.webkit.messageHandlers.getToken.postMessage("获取token");
      }
      //注册挂载全局方法等待app回调后resolve就可进行操作了
      window.getIosToken=(token) => {
        localStorage.setItem("testtkoen", token);
        resolve();
      };
    })
  return promise
  },
   //上午、下午、晚上
  getCurrentTimeText(time) {
      var currentTime = new Date(time);
      var currentHour = currentTime.getHours();
      var currentMinute = currentTime.getMinutes() > 0?currentTime.getMinutes() : '00';
      var period;
      if (currentHour < 12) {
        period = "上午";
      } else if (currentHour < 18) {
        period = "下午";
      } else {
        period = "晚上";
      };
      return period + ' ' + currentHour + ':' + currentMinute;
  },
     //早餐，午餐，晚餐
     getCurrentMeals(time) {
      var currentTime =time ? new Date(time) : new Date();
      var currentHour = currentTime.getHours();
      var currentMinute = currentTime.getMinutes() > 0?currentTime.getMinutes() : '00';
      var period;
      if ((currentHour >= 0 && currentHour < 10) || (currentHour == 10&&currentMinute < 30)) {
        period = "早餐";
      }else if((currentHour >= 11 && currentHour <= 16) ||
         (currentHour == 10&&currentMinute >= 30) ||
         (currentHour == 16&&currentMinute < 30)
         ){
        period = "午餐";
      }
       else if((currentHour > 16 && currentHour <= 24) || ((currentHour == 16&&currentMinute >= 30))){
        period = "晚餐";
      };
      return period
  },
  //保存消息已读时间
  setChatTime(imGroupId, jsbridge){
    if(!imGroupId || !jsbridge) return;
    
    // 创建一个超时Promise
    const timeout = new Promise((resolve) => {
      setTimeout(() => {
        resolve(null);
      }, 500);
    });

    // 使用Promise.race竞争
    Promise.race([
      jsbridge.getNativeInfo(),
      timeout
    ]).then(res => {
      if(!res.app_version && (getMobileOperatingSystem() =="iOS") && imGroupId) {
        saveLastOpenChatTime({imGroupId}).then(data=>{
          console.log('保存消息已读时间',res);
        })
      }
    }).catch(() => {
      console.log('获取设备信息失败');
    });
  },
  getDoctorUserStatus(){
    //0为群组,1为C2C，2为健康咨询,3用户话题群组,4为医生话题群组
    //查看自己的签约状态
      doctorUserStatus().then(res=>{
        if(res.code == 0){
          let info={
            show: false,
            title:"",
          }
          if(!res.data){
            store.dispatch('setSignedDoctor', info);
            return
          }
          //是签约中，已成功时都展示
          if(['sign_ing','sign_out_apply','sign_success'].indexOf(res?.data.signStatus) > -1){
            info={
              show: true,
              title: res.data.signStatus == "sign_success"?"家庭医生":"申请中…",
            }
          }
          store.dispatch('setSignedDoctor', {...res.data,...info});
          //签约状态：sign_fail 失败 sign_ing 签约中 sign_success 已成功 sign_rejected 已拒绝 sign_out_apply申请解约 sign_ter 已解约 sign_expired 到期
        }
      })
    },
    navigateTo(url){
      uni.navigateTo({
          url
      });
    }

};
    export default common;